// extracted by mini-css-extract-plugin
module.exports = {"main-component":"dislike_main-component__2EiV0"};